import { useEffect, useState } from "react";
import request from "superagent";
import { BACKEND_URL } from "../config/config";
import { setLoggedInUser } from "../utils/login";
import useSessionToken from "./useSessionToken";

export interface Profile {
  image?: { iconUrl: string };
  display_name?: string;
  email: string;
  uuid: string;
}

function useProfile() {
  const sessionToken = useSessionToken();
  const [profile, setProfile] = useState<Profile>();

  useEffect(() => {
    request
      .get(BACKEND_URL + `api/profile/me`)
      .set("Authorization", `Bearer ${sessionToken}`)
      .then((res) => {
        setLoggedInUser(res.body.email);
        setProfile(res.body);
      })
      .catch(() => setProfile(undefined));
  }, [sessionToken]);

  return profile;
}

export default useProfile;
